import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const RadioClassName = `${CLASS_NAME_PREFIX}-radio`;
export const RadioLabelClassName = `${RadioClassName}__label`;
export const RadioDotClassName = `${RadioClassName}__dot`;

export const RadioGroupClassName = `${CLASS_NAME_PREFIX}-radio-group`;
